// import consts from "@/consts.js";
import Request from './request'


async function fetch(data){
  return Request("get", "api/purchases/", data)
}

function delSomeFields(data) {// 去除过多杂项
  data = JSON.parse(JSON.stringify(data));// 深拷贝避免修改原数据
  delete data.actions;
  delete data.creater;
  return data;
}

async function addPreview(data) {// 新建订单预览
  data = delSomeFields(data);// 去除过多杂项
  return Request('post', "api/purchases/add-view", data);
}

async function add(data){
  // isNew
  data = delSomeFields(data)
  return Request('patch',"api/purchases/add", data)
}

async function cancel(id){
  return Request("delete",'api/purchases/cancel/' + id)
}

async function fetchOne(id,data){
  return Request("get","api/purchases/" + id,data)
}

export default {
  fetch,
  addPreview,
  add,
  cancel,
  fetchOne,
}